import React, { useState } from 'react';

import { Flex } from '@rover/kibble/core';
import { PriceTransparencyLevels } from '@rover/types/src/PriceTransparencyLevel';

import FeeExplanationBottomSheet from '../../../../search/SearchPage/components/BottomSheets/FeeExplanationBottomSheet';
import {
  PtCondensedBanner,
  PtCondensedPetTypeDescription,
} from '../../../../search/SearchPage/components/PtCondensedBanner';
import { useRevampCta } from '../../hooks/useRevampCta';
import { useRevampCtaCommon } from '../../hooks/useRevampCtaCommon';
import { SitterPriceBanner } from '../SitterPriceBanner';

import { CTAPropsCommon } from './RevampServicesCta';

const RevampMobileCtaPtBannerCommon = ({
  priceTransparencyLevel,
  petCount,
  petType,
  bookingFeePercentage,
}: Omit<CTAPropsCommon, 'locale'>): JSX.Element => {
  const { selectedService, serviceType } = useRevampCta();
  const { countryConfigUrls, isPtFull, isPtCondensed, displayPetType, petTypeServices } =
    useRevampCtaCommon(priceTransparencyLevel, petType, petCount, selectedService);
  const [isFeeExplanationModalOpen, setIsFeeExplanationModalOpen] = useState(false);

  return (
    <>
      {isPtCondensed ? (
        <Flex flexDirection="column" pb="3x" gap="2x">
          <Flex justifyContent="right">
            <PtCondensedPetTypeDescription petType={displayPetType} />
          </Flex>
          <PtCondensedBanner
            priceTransparencyLevel={priceTransparencyLevel}
            bookingFeePercentage={bookingFeePercentage}
            onClick={() => setIsFeeExplanationModalOpen(true)}
            isSitterProfile
          />
        </Flex>
      ) : (
        isPtFull && (
          <Flex mb="1x" width="100%">
            <SitterPriceBanner
              petCounts={petCount}
              petType={petType}
              serviceType={serviceType}
              countryConfigUrls={countryConfigUrls}
              bookingFeePercentage={bookingFeePercentage}
              services={petTypeServices}
              version="revamp"
            />
          </Flex>
        )
      )}
      <FeeExplanationBottomSheet
        isOpen={isFeeExplanationModalOpen}
        onClose={() => setIsFeeExplanationModalOpen(false)}
        priceTransparencyLevel={priceTransparencyLevel || PriceTransparencyLevels.lite_condensed}
        bookingPercentageFee={bookingFeePercentage}
      />
    </>
  );
};

export default RevampMobileCtaPtBannerCommon;
